module.exports = __webpack_public_path__ + "img/btn_register.278b9077.png";